const zhToEn = {
  '中文简体': 'Simplified Chinese',
  '中文': 'Chinese',
  '链接钱包': 'Connect Wallet',
  '连接钱包': 'Connect Wallet',
  '请先连接钱包': 'Please connect wallet first',
  '请先安装钱包': 'Please install or open your wallet first',
  '钱包连接失败': 'Wallet connection failed',
  '已复制': 'Copied',
  '复制成功': 'Copied successfully',
  '提示': 'Tip',
  '确定': 'OK',
  '取消': 'Cancel',
  '确认': 'Confirm',
  '提交': 'Submit',
  '提交中...': 'Submitting...',
  '处理中...': 'Processing...',
  '加载中...': 'Loading...',
  '暂无数据': 'No data',
  '暂无记录': 'No records',

  '首页': 'Home',
  '发现': 'Discover',
  '团队': 'Team',
  '我的': 'Me',
  '零钱罐': 'Asset Investment',
  '资产日志': 'My Investment',
  '社区激励': 'Community Rewards',
  '资讯': 'Info',
  '生态应用': 'Ecosystem Apps',
  '我的邀请': 'My Invitation',
  '公告': 'Announcements',
  '进入零钱罐': 'Buy Assets',
  '狗狗币是什么': 'What is Dogecoin?',
  '开源点对点的数字货币': 'Open-source peer-to-peer digital currency',
  '全世界狗狗爱好者': 'Dogecoin lovers worldwide',
  '狗狗币是一种开源的点对点数字货币，受到全球用户喜爱。mdaodogecoin 将狗狗币文化、链上资产与社区激励融合，为用户提供更直观的数字资产入口。': 'Dogecoin is an open-source peer-to-peer digital currency loved by users worldwide. mdaodogecoin combines Dogecoin culture, on-chain assets, and community incentives to provide a clearer digital asset gateway.',
  '每日正气': 'Daily Spirit',
  '我们相信社区、开放和长期主义的力量。围绕 DOGECOIN 的共识生态，mdaodogecoin 汇聚投资、邀请、公告、钱包与链上记录，让每个用户都能清晰参与。': 'We believe in community, openness, and long-termism. Around the DOGECOIN consensus ecosystem, mdaodogecoin brings together investment, invitations, announcements, wallets, and on-chain records so every user can participate clearly.',
  '资讯': 'FAQ',
  '资源': 'Resources',
  '如何上手': 'How to Start',
  '文档': 'Docs',
  '合作伙伴': 'Partners',

  '开源点对点数字资产 · 自动复利复投': 'Open peer-to-peer digital assets · Auto compounding',
  '价格：': 'Price: ',
  '投资周期：30天': 'Period: 30 days',
  '日收益': 'Daily Yield',
  '购买': 'Buy',
  '套餐1': 'Package 1',
  '套餐2': 'Package 2',
  '套餐3': 'Package 3',
  '套餐4': 'Package 4',
  '套餐5': 'Package 5',
  '套餐6': 'Package 6',
  '零钱罐': 'Piggy Bank',
  '资产包': 'Piggy Bank',

  '购买记录': 'Purchase Records',
  '全部': 'All',
  '进行中': 'Active',
  '复投中': 'Compounding',
  '已结束': 'Ended',
  '金额': 'Investment Amount',
  '收益': 'Investment Profit',
  '时间': 'Investment Time',
  '结束时间': 'End Time',
  '暂无购买记录': 'No purchase records',
  '当前还未到可转出时间': 'Transfer-out time has not arrived yet',
  '转出成功': 'Transferred successfully',
  '申请成功': 'Request submitted',
  '操作失败': 'Operation failed',
  '等待转出': 'Waiting Transfer',
  '转出': 'Transfer Out',
  '结束投资': 'End Investment',
  '待转出': 'Pending Transfer',

  '套餐详情': 'Package Details',
  '日产量': 'Daily Output',
  '投资周期': 'Investment Period',
  '个月': 'months',
  '投资类型': 'Investment Type',
  '随时随出': 'Flexible',
  '购买金额': 'Purchase Amount',
  '限购': 'Purchase Limit',
  '购买中...': 'Buying...',
  '立即购买': 'Buy Now',
  '买入成功': 'Purchase successful',
  '买入失败': 'Purchase failed',

  '我的资产': 'My Assets',
  '会员': 'Member',
  '零钱罐总资产': 'Total Investment',
  '充值': 'Deposit',
  '提现': 'Withdraw',
  '兑换': 'Exchange',
  '我的功能': 'My Functions',
  '零钱罐记录': 'Investment Records',
  '我的钱包': 'My Wallet',
  '充值记录': 'Deposit Records',
  '提现记录': 'Withdrawal Records',
  '邀请好友': 'Invite Friends',
  '我的团队': 'My Team',
  '账户安全': 'Account Security',
  '好友互转': 'Friend Transfer',
  '联系我们': 'Contact Us',
  '余额': 'Balance',

  '团队列表': 'Team List',
  '个人业绩': 'Personal Performance',
  '直推业绩': 'Direct Performance',
  '直推人数': 'Direct Invites',
  '团队人数': 'Team Members',
  '暂无团队成员': 'No team members',
  '直推成员': 'Direct Members',
  '团队成员': 'Team Members',
  '团队业绩': 'Team Performance',

  '邀请': 'Invitation',
  '携手DOGE': 'Join DOGE',
  '共创辉煌': 'Create brilliance together',
  '暂无邀请码': 'No invitation code',
  '邀请码': 'Invitation Code',
  '登录': 'Login',
  '复制': 'Copy',
  '邀请链接': 'Invitation Link',
  '暂无邀请链接': 'No invitation link',
  '暂无可复制内容': 'Nothing to copy',

  '充值到账金额': 'Deposit Arrival Amount',
  '输入到账USDT金额': 'Enter received USDT amount',
  '系统按当前DOGE': 'The system uses the current DOGE',
  '价格计算需支付DOGE数量，点击确认后将直接拉起绑定钱包向系统热钱包转账。': 'price to calculate required DOGE. After confirmation, your bound wallet will transfer to the system hot wallet.',
  '充值网络': 'Deposit Network',
  '绑定付款钱包': 'Bound Payment Wallet',
  '系统收款地址': 'System Receiving Address',
  '等待后台配置': 'Waiting for backend config',
  '合约': 'Contract',
  '最低充值': 'Minimum Deposit',
  '确认数': 'Confirmations',
  '个区块': 'blocks',
  '价格': 'Price',
  '到账金额': 'Arrival Amount',
  '需支付DOGE': 'DOGE Required',
  '价格以创建订单时锁定为准，订单有效期约': 'Price is locked when the order is created. Order expires in about',
  '分钟。': 'minutes.',
  '钱包处理中...': 'Wallet processing...',
  '确认并唤起钱包支付': 'Confirm and open wallet payment',
  '请输入充值金额': 'Please enter deposit amount',
  '请先安装或打开钱包': 'Please install or open wallet first',
  '请先连接绑定钱包': 'Please connect bound wallet first',
  '合约未配置': 'Contract not configured',
  '系统收款地址未配置': 'Receiving address not configured',
  '创建充值订单失败': 'Failed to create deposit order',
  '支付已提交，等待链上确认到账': 'Payment submitted, waiting for on-chain confirmation',
  '充值支付失败': 'Deposit payment failed',

  '闪兑提现': 'Swap Withdrawal',
  '类型': 'Type',
  '闪兑DOGE': 'Swap DOGE',
  '固定绑定钱包': 'Fixed Bound Wallet',
  '收款地址': 'Receiving Address',
  '请先连接系统绑定钱包': 'Please connect system-bound wallet first',
  '可提余额': 'Withdrawable Balance',
  '处理方式': 'Processing Method',
  '系统热钱包自动转账，地址不可修改': 'System hot wallet transfers automatically; address cannot be changed',
  '闪兑金额': 'Swap Amount',
  '请输入USDT金额': 'Enter USDT amount',
  '手续费率': 'Fee Rate',
  '手续费': 'Fee',
  '实际兑换': 'Actual Exchange',
  '预计到账': 'Estimated Arrival',
  '支付密码': 'Payment Password',
  '请输入支付密码': 'Enter payment password',
  '提交闪兑提现': 'Submit Swap Withdrawal',
  '最低闪兑金额:': 'Minimum swap amount:',
  '手续费:': 'Fee:',
  '提交后系统会扣除USDT余额，并把扣费后的金额按当前DOGE价格兑换成DOGE。': 'After submission, the system deducts USDT balance and converts the net amount to DOGE at current price.',
  '提现只能提现到系统绑定钱包地址，不能手动修改地址。': 'Withdrawals can only go to the system-bound wallet address and cannot be edited manually.',
  '请输入闪兑金额': 'Please enter swap amount',
  '闪兑提现已提交，等待系统热钱包转账': 'Swap withdrawal submitted, waiting for system hot wallet transfer',
  '提现失败': 'Withdrawal failed',

  '兑换记录': 'Exchange Records',
  '兑换DOGE': 'Exchange DOGE',
  '地址：': 'Address:',
  '待出金': 'Pending Payout',
  '链上确认中': 'On-chain Confirming',
  '成功': 'Success',
  '失败': 'Failed',
  '等待链上确认': 'Waiting on-chain confirmation',
  '已到账': 'Arrived',
  '收入': 'Income',
  '投资': 'Investment',
  '支出': 'Expense',
  '提现记录': 'Withdrawal Records',
  '充值记录': 'Deposit Records',
  '资金明细': 'Fund Details',
  '闪兑提现': 'Swap Withdrawal',
  '钱包充值': 'Wallet Deposit',
  '流水': 'Ledger',

  '好友账户': 'Friend Account',
  '好友地址': 'Friend Address',
  '请输入好友钱包地址': 'Enter friend wallet address',
  '手机号': 'Phone',
  '邮箱': 'Email',
  '数量': 'Amount',
  '请输入数量': 'Enter amount',
  '最多': 'Max',
  '最多可转：': 'Max transferable:',
  '请输入好友账号和数量': 'Please enter friend account and amount',
  '互转失败': 'Transfer failed',
  '互转成功': 'Transfer successful',

  '官方客服与社区联系方式': 'Official support and community contacts',
  '暂无联系方式': 'No contact info',
  '暂无公告内容': 'No announcement content',
  '时间：': 'Time:',
  '公告不存在或已下线': 'Announcement does not exist or is offline',
  '暂无公告': 'No announcements',

  'DOGE生态说明': 'DOGE Ecosystem Overview',
  '生态说明': 'Ecosystem Overview',
  '用户可使用站内 USDT 买入 DOGE 生态零钱罐，零钱罐收益按后台配置执行。': 'Users can use in-site USDT to buy DOGE ecosystem piggy bank products. Rewards follow backend settings.',
  '首次买入后犹豫期内支持转出': 'Transfer-out is supported during the grace period after first purchase.',
  '超过犹豫期后，收益按规则进入可用余额或自动复投。': 'After the grace period, earnings enter available balance or auto-compound according to rules.',
  '申请结束投资后进入等待期，开放转出窗口内可将零钱罐余额转回站内可用余额。': 'After applying to end investment, it enters a waiting period. During the transfer window, the piggy bank balance can be moved back to the available balance.',
  '动态奖励包含直推、M1-M9级差和平级奖，等级与比例以后端配置为准。': 'Dynamic rewards include direct referral, M1-M9 level differences, and same-level rewards. Levels and rates follow backend configuration.',
  '进入零钱罐': 'Go to Asset Investment',

  '生态账户': 'Ecosystem Account',
  '头像': 'Avatar',
  '昵称': 'Nickname',
  '登录钱包': 'Login Wallet',
  '修改': 'Change',
  '设置': 'Set',
  '修改支付密码': 'Change Payment Password',
  '设置支付密码': 'Set Payment Password',
  '验证码将发送到当前账户绑定的手机或邮箱，用于确认是本人操作。': 'A verification code will be sent to the phone or email bound to this account to confirm your identity.',
  '接收账号': 'Receiving Account',
  '请输入验证码': 'Enter verification code',
  '请输入6-16位新支付密码': 'Enter a 6-16 digit new payment password',
  '手机）': 'Phone)',
  '邮箱）': 'Email)',
  '当前账户未绑定手机或邮箱': 'Current account has no bound phone or email',
  '秒后重发': 's to resend',
  '发送中...': 'Sending...',
  '发送验证码': 'Send Code',
  '当前账户未绑定手机或邮箱，暂时无法设置支付密码': 'No phone or email is bound, payment password cannot be set now',
  '当前账户未绑定手机或邮箱，无法发送验证码': 'No phone or email is bound, cannot send verification code',
  '发送失败': 'Send failed',
  '验证码已发送': 'Verification code sent',
  '验证码发送失败': 'Failed to send verification code',
  '请输入验证码和新密码': 'Please enter verification code and new password',
  '密码只能在6-16位之间': 'Password must be 6-16 characters',
  '操作成功': 'Operation successful',
  '操作失败，请稍后重试': 'Operation failed, please try again later',

  '添加邀请人': 'Add Inviter',
  '请输入上级邀请码': 'Enter inviter code',
  '绑定成功': 'Bound successfully',
  '绑定失败': 'Binding failed',
  '网络错误，绑定失败': 'Network error, binding failed',
  '添加提币账号': 'Add Withdrawal Account',
  '请输入BSC提币地址': 'Enter BSC withdrawal address',
  '添加': 'Add',
  '已绑定地址': 'Bound Address',
  '暂无绑定地址': 'No bound address',
  '请输入地址': 'Please enter address'
};

const sortedKeys = Object.keys(zhToEn).sort((a, b) => b.length - a.length);

export function translateDomText(text, locale) {
  if (locale !== 'en' || !text) return text;
  let out = text;
  if (zhToEn[out]) return zhToEn[out];
  for (const key of sortedKeys) {
    if (out.includes(key)) out = out.split(key).join(zhToEn[key]);
  }
  out = out.replace(/套餐(\d+)/g, 'Package $1')
    .replace(/[。；]+/g, '. ')
    .replace(/，/g, ', ')
    .replace(/：/g, ': ')
    .replace(/、/g, ', ')
    .replace(/\s+([,.])/g, '$1')
    .replace(/\.\s*\./g, '.')
    .replace(/\s{2,}/g, ' ')
    .replace(/价格[:：]\s*/g, 'Price: ')
    .replace(/投资周期[:：]\s*(\d+)天/g, 'Period: $1 days')
    .replace(/(\d+)天/g, '$1 days')
    .replace(/(\d+)个区块/g, '$1 blocks')
    .replace(/(\d+)分钟/g, '$1 minutes');
  return out;
}

export default zhToEn;
